const ACTION_KEY = 'REPORT_PRODUCTION';

const initialState = () => ({
  loading: false,
  reportProduction: null,
  error: null,
  required: false,
  paramsFilter: {
    dateFrom: null,
    dateTo: null,
    responsibleType: null,
    businessPartners: [],
    professions: [],
    branchs: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    // TODO deve ser descontinuado e dar lugar ao "agrupamento por paciente"
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_FULFILLED`: {
      const reportProduction = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProduction,
        paramsFilter
      };
    }

    // TODO deve tomar o lugar do "desagrupado"
    case `${ACTION_KEY}_BY_PATIENT_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_BY_PATIENT_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_BY_PATIENT_FULFILLED`: {
      const reportProduction = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProduction,
        paramsFilter
      };
    }

    // TODO deve ser descontinuado e dar lugar ao "agrupamento por paciente/profissão"
    case `${ACTION_KEY}_PROFESSION_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_PROFESSION_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_PROFESSION_FULFILLED`: {
      const reportProduction = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProduction,
        paramsFilter
      };
    }

    // TODO deve tomar o lugar de "agrupamento por profissão"
    case `${ACTION_KEY}_BY_PATIENT_AND_PROFESSION_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_BY_PATIENT_AND_PROFESSION_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_BY_PATIENT_AND_PROFESSION_FULFILLED`: {
      const reportProduction = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProduction,
        paramsFilter
      };
    }

    // TODO deve ser descontinuado e dar lugar ao "agrupamento por paciente/profissional"
    case `${ACTION_KEY}_PROFESSIONAL_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_PROFESSIONAL_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_PROFESSIONAL_FULFILLED`: {
      const reportProduction = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProduction,
        paramsFilter
      };
    }

    // TODO deve tomar o lugar de "agrupamento por profissional"
    case `${ACTION_KEY}_PATIENT_AND_PROFESSIONAL_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_PATIENT_AND_PROFESSIONAL_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_PATIENT_AND_PROFESSIONAL_FULFILLED`: {
      const reportProduction = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProduction,
        paramsFilter
      };
    }

    // TODO novo agrupamento
    case `${ACTION_KEY}_PROFESSIONAL_AND_PATIENT_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_PROFESSIONAL_AND_PATIENT_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_PROFESSIONAL_AND_PATIENT_FULFILLED`: {
      const reportProduction = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProduction,
        paramsFilter
      };
    }

    case `${ACTION_KEY}_DOWNLOAD_PDF_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${ACTION_KEY}_DOWNLOAD_PDF_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_DOWNLOAD_PDF_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    // TODO deve ser descontinuado e dar lugar ao "agrupado por paciente"
    case `${ACTION_KEY}_CSV_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${ACTION_KEY}_CSV_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_CSV_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    // TODO deve tomar o lugar do "desagrupado"
    case `${ACTION_KEY}_BY_PATIENT_CSV_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${ACTION_KEY}_BY_PATIENT_CSV_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_BY_PATIENT_CSV_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    // TODO deve ser descontinuado e dar lugar ao "agrupamento por paciente/profissão"
    case `${ACTION_KEY}_CSV_PROFESSION_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_CSV_PROFESSION_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_CSV_PROFESSION_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    // TODO deve tomar o lugar de "agrupamento por profissão"
    case `${ACTION_KEY}_BY_PATIENT_AND_PROFESSION_CSV_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_BY_PATIENT_AND_PROFESSION_CSV_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_BY_PATIENT_AND_PROFESSION_CSV_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    // TODO deve ser descontinuado e dar lugar ao "agrupamento por profissional/paciente"
    case `${ACTION_KEY}_CSV_PROFESSIONAL_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_CSV_PROFESSIONAL_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_CSV_PROFESSIONAL_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    // TODO deve tomar o lugar de "agrupamento por profissional"
    case `${ACTION_KEY}_PATIENT_AND_PROFESSIONAL_CSV_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_PATIENT_AND_PROFESSIONAL_CSV_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_PATIENT_AND_PROFESSIONAL_CSV_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    // TODO novo agrupamento
    case `${ACTION_KEY}_PROFESSIONAL_AND_PATIENT_CSV_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_PROFESSIONAL_AND_PATIENT_CSV_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_PROFESSIONAL_AND_PATIENT_CSV_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
